/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * CIT
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BooleanApiResponse,
  CourseDetailResApiResponse,
  CourseDetailsReq,
  CourseDetailsResponseApiResponse,
  CurrentSchemaResponseApiResponse,
  FacultyDetailResApiResponse,
  FacultyDetailsReq,
  GetAPIMastersBatchSearchingParams,
  GetAPIMastersCoursesByDepartmentParams,
  GetAPIMastersCurrentSchemasByCourseParams,
  GetAPIMastersDeleteParams,
  GetAPIMastersDownloadCardsPdfParams,
  GetAPIMastersGetAllMastersParams,
  GetAPIMastersGetBatchByDepartmentParams,
  GetAPIMastersGetSemesterDataParams,
  GetAPIMastersGetSemesterListBySessionIdParams,
  GetAPIMastersGetSessionListByCourseIdParams,
  GetAPIMastersGetStudentIDCardDetailsParams,
  GetAPIMastersGetStudentListParams,
  GetAPIMastersGetSubjectListBySessionIdParams,
  GetAPIMastersIdParams,
  GetAPIMastersParams,
  GetAPIMastersSchemasByCourseParams,
  GetAPIMastersSchemasParams,
  GetAPIMastersSearchParams,
  GetAPIMastersSemesterWithSubjectsParams,
  GetAPIMastersSemestersByDepartmentParams,
  GetAPIMastersSubjectsByDepartmentParams,
  GetAllDesignCourseDetailsResApiResponse,
  GetAllMasterResponsePagedDataApiResponse,
  IdNameModel,
  IdNameModelListApiResponse,
  Master,
  MasterApiResponse,
  MasterListApiResponse,
  MasterPagedDataApiResponse,
  MasterSearchResponsePagedDataApiResponse,
  PostAPIMastersCurrentSchemaParams,
  PostAPIMastersStatusActionBody,
  PostAPIMastersStatusActionParams,
  PostAPIMastersUpdateFacultyDetailRecordStatusParams,
  PostAPIMastersUpdateRecordStatusForShiftParams,
  PostAPIMastersUpdateRecordStatusParams,
  SchemaResponsePagedDataApiResponse,
  SectionDetailResApiResponse,
  SectionDetailsReq,
  StudentIDCardDetailsListApiResponse,
  SubjectAllocationMasterDetailsReq,
  SubjectAllocationMasterDetailsResApiResponse,
  ViewStudentListForIdCardListApiResponse
} from '../cit.schemas';

import { customAxios } from '../../../Utilities/customAxios';




export const getAPIMasters = (
    params?: GetAPIMastersParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterPagedDataApiResponse>(
      {url: `/API/Masters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersQueryKey = (params?: GetAPIMastersParams,) => {
    return [`/API/Masters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMasters>>, TError = unknown>(params?: GetAPIMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMasters>>> = ({ signal }) => getAPIMasters(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMasters>>>
export type GetAPIMastersQueryError = unknown


export function useGetAPIMasters<TData = Awaited<ReturnType<typeof getAPIMasters>>, TError = unknown>(
 params: undefined |  GetAPIMastersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMasters>>,
          TError,
          Awaited<ReturnType<typeof getAPIMasters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMasters<TData = Awaited<ReturnType<typeof getAPIMasters>>, TError = unknown>(
 params?: GetAPIMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMasters>>,
          TError,
          Awaited<ReturnType<typeof getAPIMasters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMasters<TData = Awaited<ReturnType<typeof getAPIMasters>>, TError = unknown>(
 params?: GetAPIMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMasters<TData = Awaited<ReturnType<typeof getAPIMasters>>, TError = unknown>(
 params?: GetAPIMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMasters>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIMasters = (
    master: Master,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterApiResponse>(
      {url: `/API/Masters`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: master, signal
    },
      );
    }
  


export const getPostAPIMastersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMasters>>, TError,{data: Master}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMasters>>, TError,{data: Master}, TContext> => {
    
const mutationKey = ['postAPIMasters'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMasters>>, {data: Master}> = (props) => {
          const {data} = props ?? {};

          return  postAPIMasters(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMasters>>>
    export type PostAPIMastersMutationBody = Master
    export type PostAPIMastersMutationError = unknown

    export const usePostAPIMasters = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMasters>>, TError,{data: Master}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMasters>>,
        TError,
        {data: Master},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postAPIMastersUpdateRecordStatus = (
    params?: PostAPIMastersUpdateRecordStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BooleanApiResponse>(
      {url: `/API/Masters/UpdateRecordStatus`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getPostAPIMastersUpdateRecordStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>, TError,{params?: PostAPIMastersUpdateRecordStatusParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>, TError,{params?: PostAPIMastersUpdateRecordStatusParams}, TContext> => {
    
const mutationKey = ['postAPIMastersUpdateRecordStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>, {params?: PostAPIMastersUpdateRecordStatusParams}> = (props) => {
          const {params} = props ?? {};

          return  postAPIMastersUpdateRecordStatus(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersUpdateRecordStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>>
    
    export type PostAPIMastersUpdateRecordStatusMutationError = unknown

    export const usePostAPIMastersUpdateRecordStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>, TError,{params?: PostAPIMastersUpdateRecordStatusParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatus>>,
        TError,
        {params?: PostAPIMastersUpdateRecordStatusParams},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersUpdateRecordStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIMastersId = (
    id: string,
    params?: GetAPIMastersIdParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterApiResponse>(
      {url: `/API/Masters/${id}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersIdQueryKey = (id: string,
    params?: GetAPIMastersIdParams,) => {
    return [`/API/Masters/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersIdQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersId>>, TError = unknown>(id: string,
    params?: GetAPIMastersIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersId>>> = ({ signal }) => getAPIMastersId(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersId>>>
export type GetAPIMastersIdQueryError = unknown


export function useGetAPIMastersId<TData = Awaited<ReturnType<typeof getAPIMastersId>>, TError = unknown>(
 id: string,
    params: undefined |  GetAPIMastersIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersId<TData = Awaited<ReturnType<typeof getAPIMastersId>>, TError = unknown>(
 id: string,
    params?: GetAPIMastersIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersId<TData = Awaited<ReturnType<typeof getAPIMastersId>>, TError = unknown>(
 id: string,
    params?: GetAPIMastersIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersId<TData = Awaited<ReturnType<typeof getAPIMastersId>>, TError = unknown>(
 id: string,
    params?: GetAPIMastersIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersDelete = (
    params?: GetAPIMastersDeleteParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterApiResponse>(
      {url: `/API/Masters/Delete`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersDeleteQueryKey = (params?: GetAPIMastersDeleteParams,) => {
    return [`/API/Masters/Delete`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersDeleteQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersDelete>>, TError = unknown>(params?: GetAPIMastersDeleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersDeleteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersDelete>>> = ({ signal }) => getAPIMastersDelete(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersDelete>>>
export type GetAPIMastersDeleteQueryError = unknown


export function useGetAPIMastersDelete<TData = Awaited<ReturnType<typeof getAPIMastersDelete>>, TError = unknown>(
 params: undefined |  GetAPIMastersDeleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersDelete>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersDelete>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersDelete<TData = Awaited<ReturnType<typeof getAPIMastersDelete>>, TError = unknown>(
 params?: GetAPIMastersDeleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersDelete>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersDelete>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersDelete<TData = Awaited<ReturnType<typeof getAPIMastersDelete>>, TError = unknown>(
 params?: GetAPIMastersDeleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersDelete<TData = Awaited<ReturnType<typeof getAPIMastersDelete>>, TError = unknown>(
 params?: GetAPIMastersDeleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDelete>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersDeleteQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSearch = (
    params?: GetAPIMastersSearchParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterSearchResponsePagedDataApiResponse>(
      {url: `/API/Masters/Search`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSearchQueryKey = (params?: GetAPIMastersSearchParams,) => {
    return [`/API/Masters/Search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSearchQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSearch>>, TError = unknown>(params?: GetAPIMastersSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSearch>>> = ({ signal }) => getAPIMastersSearch(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSearch>>>
export type GetAPIMastersSearchQueryError = unknown


export function useGetAPIMastersSearch<TData = Awaited<ReturnType<typeof getAPIMastersSearch>>, TError = unknown>(
 params: undefined |  GetAPIMastersSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSearch>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSearch<TData = Awaited<ReturnType<typeof getAPIMastersSearch>>, TError = unknown>(
 params?: GetAPIMastersSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSearch>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSearch<TData = Awaited<ReturnType<typeof getAPIMastersSearch>>, TError = unknown>(
 params?: GetAPIMastersSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSearch<TData = Awaited<ReturnType<typeof getAPIMastersSearch>>, TError = unknown>(
 params?: GetAPIMastersSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSearch>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSearchQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersBatchSearching = (
    params?: GetAPIMastersBatchSearchingParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterPagedDataApiResponse>(
      {url: `/API/Masters/batchSearching`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersBatchSearchingQueryKey = (params?: GetAPIMastersBatchSearchingParams,) => {
    return [`/API/Masters/batchSearching`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersBatchSearchingQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError = unknown>(params?: GetAPIMastersBatchSearchingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersBatchSearchingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>> = ({ signal }) => getAPIMastersBatchSearching(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersBatchSearchingQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>>
export type GetAPIMastersBatchSearchingQueryError = unknown


export function useGetAPIMastersBatchSearching<TData = Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError = unknown>(
 params: undefined |  GetAPIMastersBatchSearchingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersBatchSearching>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersBatchSearching>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersBatchSearching<TData = Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError = unknown>(
 params?: GetAPIMastersBatchSearchingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersBatchSearching>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersBatchSearching>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersBatchSearching<TData = Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError = unknown>(
 params?: GetAPIMastersBatchSearchingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersBatchSearching<TData = Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError = unknown>(
 params?: GetAPIMastersBatchSearchingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersBatchSearching>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersBatchSearchingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSchemas = (
    params?: GetAPIMastersSchemasParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<SchemaResponsePagedDataApiResponse>(
      {url: `/API/Masters/Schemas`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSchemasQueryKey = (params?: GetAPIMastersSchemasParams,) => {
    return [`/API/Masters/Schemas`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSchemasQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError = unknown>(params?: GetAPIMastersSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSchemasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSchemas>>> = ({ signal }) => getAPIMastersSchemas(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSchemas>>>
export type GetAPIMastersSchemasQueryError = unknown


export function useGetAPIMastersSchemas<TData = Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError = unknown>(
 params: undefined |  GetAPIMastersSchemasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSchemas>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSchemas>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSchemas<TData = Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError = unknown>(
 params?: GetAPIMastersSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSchemas>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSchemas>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSchemas<TData = Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError = unknown>(
 params?: GetAPIMastersSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSchemas<TData = Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError = unknown>(
 params?: GetAPIMastersSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemas>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSchemasQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSubjectsByDepartment = (
    params?: GetAPIMastersSubjectsByDepartmentParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<IdNameModelListApiResponse>(
      {url: `/API/Masters/SubjectsByDepartment`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSubjectsByDepartmentQueryKey = (params?: GetAPIMastersSubjectsByDepartmentParams,) => {
    return [`/API/Masters/SubjectsByDepartment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSubjectsByDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError = unknown>(params?: GetAPIMastersSubjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSubjectsByDepartmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>> = ({ signal }) => getAPIMastersSubjectsByDepartment(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSubjectsByDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>>
export type GetAPIMastersSubjectsByDepartmentQueryError = unknown


export function useGetAPIMastersSubjectsByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError = unknown>(
 params: undefined |  GetAPIMastersSubjectsByDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSubjectsByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSubjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSubjectsByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSubjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSubjectsByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSubjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSubjectsByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSubjectsByDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetBatchByDepartment = (
    params?: GetAPIMastersGetBatchByDepartmentParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<IdNameModelListApiResponse>(
      {url: `/API/Masters/GetBatchByDepartment`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetBatchByDepartmentQueryKey = (params?: GetAPIMastersGetBatchByDepartmentParams,) => {
    return [`/API/Masters/GetBatchByDepartment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetBatchByDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError = unknown>(params?: GetAPIMastersGetBatchByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetBatchByDepartmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>> = ({ signal }) => getAPIMastersGetBatchByDepartment(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetBatchByDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>>
export type GetAPIMastersGetBatchByDepartmentQueryError = unknown


export function useGetAPIMastersGetBatchByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetBatchByDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetBatchByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError = unknown>(
 params?: GetAPIMastersGetBatchByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetBatchByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError = unknown>(
 params?: GetAPIMastersGetBatchByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetBatchByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError = unknown>(
 params?: GetAPIMastersGetBatchByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetBatchByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetBatchByDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSemestersByDepartment = (
    params?: GetAPIMastersSemestersByDepartmentParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<IdNameModelListApiResponse>(
      {url: `/API/Masters/SemestersByDepartment`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSemestersByDepartmentQueryKey = (params?: GetAPIMastersSemestersByDepartmentParams,) => {
    return [`/API/Masters/SemestersByDepartment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSemestersByDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError = unknown>(params?: GetAPIMastersSemestersByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSemestersByDepartmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>> = ({ signal }) => getAPIMastersSemestersByDepartment(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSemestersByDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>>
export type GetAPIMastersSemestersByDepartmentQueryError = unknown


export function useGetAPIMastersSemestersByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError = unknown>(
 params: undefined |  GetAPIMastersSemestersByDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSemestersByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSemestersByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSemestersByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSemestersByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSemestersByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError = unknown>(
 params?: GetAPIMastersSemestersByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemestersByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSemestersByDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersCoursesByDepartment = (
    params?: GetAPIMastersCoursesByDepartmentParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<IdNameModelListApiResponse>(
      {url: `/API/Masters/CoursesByDepartment`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersCoursesByDepartmentQueryKey = (params?: GetAPIMastersCoursesByDepartmentParams,) => {
    return [`/API/Masters/CoursesByDepartment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersCoursesByDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError = unknown>(params?: GetAPIMastersCoursesByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersCoursesByDepartmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>> = ({ signal }) => getAPIMastersCoursesByDepartment(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersCoursesByDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>>
export type GetAPIMastersCoursesByDepartmentQueryError = unknown


export function useGetAPIMastersCoursesByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError = unknown>(
 params: undefined |  GetAPIMastersCoursesByDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersCoursesByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError = unknown>(
 params?: GetAPIMastersCoursesByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersCoursesByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError = unknown>(
 params?: GetAPIMastersCoursesByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersCoursesByDepartment<TData = Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError = unknown>(
 params?: GetAPIMastersCoursesByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCoursesByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersCoursesByDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSchemasByCourse = (
    params?: GetAPIMastersSchemasByCourseParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<IdNameModelListApiResponse>(
      {url: `/API/Masters/SchemasByCourse`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSchemasByCourseQueryKey = (params?: GetAPIMastersSchemasByCourseParams,) => {
    return [`/API/Masters/SchemasByCourse`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSchemasByCourseQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError = unknown>(params?: GetAPIMastersSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSchemasByCourseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>> = ({ signal }) => getAPIMastersSchemasByCourse(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSchemasByCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>>
export type GetAPIMastersSchemasByCourseQueryError = unknown


export function useGetAPIMastersSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError = unknown>(
 params: undefined |  GetAPIMastersSchemasByCourseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSchemasByCourse>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSchemasByCourseQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIMastersCurrentSchema = (
    idNameModel: IdNameModel,
    params?: PostAPIMastersCurrentSchemaParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterApiResponse>(
      {url: `/API/Masters/CurrentSchema`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: idNameModel,
        params, signal
    },
      );
    }
  


export const getPostAPIMastersCurrentSchemaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>, TError,{data: IdNameModel;params?: PostAPIMastersCurrentSchemaParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>, TError,{data: IdNameModel;params?: PostAPIMastersCurrentSchemaParams}, TContext> => {
    
const mutationKey = ['postAPIMastersCurrentSchema'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>, {data: IdNameModel;params?: PostAPIMastersCurrentSchemaParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAPIMastersCurrentSchema(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersCurrentSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>>
    export type PostAPIMastersCurrentSchemaMutationBody = IdNameModel
    export type PostAPIMastersCurrentSchemaMutationError = unknown

    export const usePostAPIMastersCurrentSchema = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>, TError,{data: IdNameModel;params?: PostAPIMastersCurrentSchemaParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersCurrentSchema>>,
        TError,
        {data: IdNameModel;params?: PostAPIMastersCurrentSchemaParams},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersCurrentSchemaMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIMastersCurrentSchemasByCourse = (
    params?: GetAPIMastersCurrentSchemasByCourseParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<CurrentSchemaResponseApiResponse>(
      {url: `/API/Masters/CurrentSchemasByCourse`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersCurrentSchemasByCourseQueryKey = (params?: GetAPIMastersCurrentSchemasByCourseParams,) => {
    return [`/API/Masters/CurrentSchemasByCourse`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersCurrentSchemasByCourseQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError = unknown>(params?: GetAPIMastersCurrentSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersCurrentSchemasByCourseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>> = ({ signal }) => getAPIMastersCurrentSchemasByCourse(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersCurrentSchemasByCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>>
export type GetAPIMastersCurrentSchemasByCourseQueryError = unknown


export function useGetAPIMastersCurrentSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError = unknown>(
 params: undefined |  GetAPIMastersCurrentSchemasByCourseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersCurrentSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersCurrentSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersCurrentSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersCurrentSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersCurrentSchemasByCourse<TData = Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError = unknown>(
 params?: GetAPIMastersCurrentSchemasByCourseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersCurrentSchemasByCourse>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersCurrentSchemasByCourseQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersSemesterWithSubjects = (
    params?: GetAPIMastersSemesterWithSubjectsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<CourseDetailsResponseApiResponse>(
      {url: `/API/Masters/SemesterWithSubjects`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersSemesterWithSubjectsQueryKey = (params?: GetAPIMastersSemesterWithSubjectsParams,) => {
    return [`/API/Masters/SemesterWithSubjects`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersSemesterWithSubjectsQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError = unknown>(params?: GetAPIMastersSemesterWithSubjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersSemesterWithSubjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>> = ({ signal }) => getAPIMastersSemesterWithSubjects(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersSemesterWithSubjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>>
export type GetAPIMastersSemesterWithSubjectsQueryError = unknown


export function useGetAPIMastersSemesterWithSubjects<TData = Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError = unknown>(
 params: undefined |  GetAPIMastersSemesterWithSubjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSemesterWithSubjects<TData = Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError = unknown>(
 params?: GetAPIMastersSemesterWithSubjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersSemesterWithSubjects<TData = Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError = unknown>(
 params?: GetAPIMastersSemesterWithSubjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersSemesterWithSubjects<TData = Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError = unknown>(
 params?: GetAPIMastersSemesterWithSubjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersSemesterWithSubjects>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersSemesterWithSubjectsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIMastersStatusAction = (
    postAPIMastersStatusActionBody: PostAPIMastersStatusActionBody,
    params?: PostAPIMastersStatusActionParams,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postAPIMastersStatusActionBody.saveRequestList !== undefined) {
 postAPIMastersStatusActionBody.saveRequestList.forEach(value => formData.append('saveRequestList', value));
 }

      return customAxios<MasterListApiResponse>(
      {url: `/API/Masters/StatusAction`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      );
    }
  


export const getPostAPIMastersStatusActionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersStatusAction>>, TError,{data: PostAPIMastersStatusActionBody;params?: PostAPIMastersStatusActionParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersStatusAction>>, TError,{data: PostAPIMastersStatusActionBody;params?: PostAPIMastersStatusActionParams}, TContext> => {
    
const mutationKey = ['postAPIMastersStatusAction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersStatusAction>>, {data: PostAPIMastersStatusActionBody;params?: PostAPIMastersStatusActionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAPIMastersStatusAction(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersStatusActionMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersStatusAction>>>
    export type PostAPIMastersStatusActionMutationBody = PostAPIMastersStatusActionBody
    export type PostAPIMastersStatusActionMutationError = unknown

    export const usePostAPIMastersStatusAction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersStatusAction>>, TError,{data: PostAPIMastersStatusActionBody;params?: PostAPIMastersStatusActionParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersStatusAction>>,
        TError,
        {data: PostAPIMastersStatusActionBody;params?: PostAPIMastersStatusActionParams},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersStatusActionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIMastersGetAllMasters = (
    params?: GetAPIMastersGetAllMastersParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<GetAllMasterResponsePagedDataApiResponse>(
      {url: `/API/Masters/GetAllMasters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetAllMastersQueryKey = (params?: GetAPIMastersGetAllMastersParams,) => {
    return [`/API/Masters/GetAllMasters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetAllMastersQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError = unknown>(params?: GetAPIMastersGetAllMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetAllMastersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>> = ({ signal }) => getAPIMastersGetAllMasters(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetAllMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>>
export type GetAPIMastersGetAllMastersQueryError = unknown


export function useGetAPIMastersGetAllMasters<TData = Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetAllMastersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetAllMasters<TData = Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError = unknown>(
 params?: GetAPIMastersGetAllMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetAllMasters<TData = Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError = unknown>(
 params?: GetAPIMastersGetAllMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetAllMasters<TData = Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError = unknown>(
 params?: GetAPIMastersGetAllMastersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllMasters>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetAllMastersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetSemesterData = (
    params?: GetAPIMastersGetSemesterDataParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterPagedDataApiResponse>(
      {url: `/API/Masters/GetSemesterData`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetSemesterDataQueryKey = (params?: GetAPIMastersGetSemesterDataParams,) => {
    return [`/API/Masters/GetSemesterData`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetSemesterDataQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError = unknown>(params?: GetAPIMastersGetSemesterDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetSemesterDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>> = ({ signal }) => getAPIMastersGetSemesterData(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetSemesterDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>>
export type GetAPIMastersGetSemesterDataQueryError = unknown


export function useGetAPIMastersGetSemesterData<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetSemesterDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSemesterData<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSemesterData<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetSemesterData<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterData>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetSemesterDataQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetSessionListByCourseId = (
    params?: GetAPIMastersGetSessionListByCourseIdParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterListApiResponse>(
      {url: `/API/Masters/GetSessionListByCourseId`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetSessionListByCourseIdQueryKey = (params?: GetAPIMastersGetSessionListByCourseIdParams,) => {
    return [`/API/Masters/GetSessionListByCourseId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetSessionListByCourseIdQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError = unknown>(params?: GetAPIMastersGetSessionListByCourseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetSessionListByCourseIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>> = ({ signal }) => getAPIMastersGetSessionListByCourseId(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetSessionListByCourseIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>>
export type GetAPIMastersGetSessionListByCourseIdQueryError = unknown


export function useGetAPIMastersGetSessionListByCourseId<TData = Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetSessionListByCourseIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSessionListByCourseId<TData = Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError = unknown>(
 params?: GetAPIMastersGetSessionListByCourseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSessionListByCourseId<TData = Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError = unknown>(
 params?: GetAPIMastersGetSessionListByCourseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetSessionListByCourseId<TData = Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError = unknown>(
 params?: GetAPIMastersGetSessionListByCourseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSessionListByCourseId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetSessionListByCourseIdQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetSemesterListBySessionId = (
    params?: GetAPIMastersGetSemesterListBySessionIdParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterListApiResponse>(
      {url: `/API/Masters/GetSemesterListBySessionId`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetSemesterListBySessionIdQueryKey = (params?: GetAPIMastersGetSemesterListBySessionIdParams,) => {
    return [`/API/Masters/GetSemesterListBySessionId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetSemesterListBySessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError = unknown>(params?: GetAPIMastersGetSemesterListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetSemesterListBySessionIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>> = ({ signal }) => getAPIMastersGetSemesterListBySessionId(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetSemesterListBySessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>>
export type GetAPIMastersGetSemesterListBySessionIdQueryError = unknown


export function useGetAPIMastersGetSemesterListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetSemesterListBySessionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSemesterListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSemesterListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetSemesterListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSemesterListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSemesterListBySessionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetSemesterListBySessionIdQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetSubjectListBySessionId = (
    params?: GetAPIMastersGetSubjectListBySessionIdParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MasterListApiResponse>(
      {url: `/API/Masters/GetSubjectListBySessionId`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetSubjectListBySessionIdQueryKey = (params?: GetAPIMastersGetSubjectListBySessionIdParams,) => {
    return [`/API/Masters/GetSubjectListBySessionId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetSubjectListBySessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError = unknown>(params?: GetAPIMastersGetSubjectListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetSubjectListBySessionIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>> = ({ signal }) => getAPIMastersGetSubjectListBySessionId(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetSubjectListBySessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>>
export type GetAPIMastersGetSubjectListBySessionIdQueryError = unknown


export function useGetAPIMastersGetSubjectListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetSubjectListBySessionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSubjectListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSubjectListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetSubjectListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSubjectListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetSubjectListBySessionId<TData = Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError = unknown>(
 params?: GetAPIMastersGetSubjectListBySessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetSubjectListBySessionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetSubjectListBySessionIdQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIMastersGetCourseDetails = (
    courseDetailsReq: CourseDetailsReq,
 signal?: AbortSignal
) => {
      
      
      return customAxios<CourseDetailResApiResponse>(
      {url: `/API/Masters/GetCourseDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: courseDetailsReq, signal
    },
      );
    }
  


export const getPostAPIMastersGetCourseDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>, TError,{data: CourseDetailsReq}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>, TError,{data: CourseDetailsReq}, TContext> => {
    
const mutationKey = ['postAPIMastersGetCourseDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>, {data: CourseDetailsReq}> = (props) => {
          const {data} = props ?? {};

          return  postAPIMastersGetCourseDetails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersGetCourseDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>>
    export type PostAPIMastersGetCourseDetailsMutationBody = CourseDetailsReq
    export type PostAPIMastersGetCourseDetailsMutationError = unknown

    export const usePostAPIMastersGetCourseDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>, TError,{data: CourseDetailsReq}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersGetCourseDetails>>,
        TError,
        {data: CourseDetailsReq},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersGetCourseDetailsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postAPIMastersGetFacultyDetails = (
    facultyDetailsReq: FacultyDetailsReq,
 signal?: AbortSignal
) => {
      
      
      return customAxios<FacultyDetailResApiResponse>(
      {url: `/API/Masters/GetFacultyDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: facultyDetailsReq, signal
    },
      );
    }
  


export const getPostAPIMastersGetFacultyDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>, TError,{data: FacultyDetailsReq}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>, TError,{data: FacultyDetailsReq}, TContext> => {
    
const mutationKey = ['postAPIMastersGetFacultyDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>, {data: FacultyDetailsReq}> = (props) => {
          const {data} = props ?? {};

          return  postAPIMastersGetFacultyDetails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersGetFacultyDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>>
    export type PostAPIMastersGetFacultyDetailsMutationBody = FacultyDetailsReq
    export type PostAPIMastersGetFacultyDetailsMutationError = unknown

    export const usePostAPIMastersGetFacultyDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>, TError,{data: FacultyDetailsReq}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersGetFacultyDetails>>,
        TError,
        {data: FacultyDetailsReq},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersGetFacultyDetailsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postAPIMastersGetSectionsDetails = (
    sectionDetailsReq: SectionDetailsReq,
 signal?: AbortSignal
) => {
      
      
      return customAxios<SectionDetailResApiResponse>(
      {url: `/API/Masters/GetSectionsDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: sectionDetailsReq, signal
    },
      );
    }
  


export const getPostAPIMastersGetSectionsDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>, TError,{data: SectionDetailsReq}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>, TError,{data: SectionDetailsReq}, TContext> => {
    
const mutationKey = ['postAPIMastersGetSectionsDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>, {data: SectionDetailsReq}> = (props) => {
          const {data} = props ?? {};

          return  postAPIMastersGetSectionsDetails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersGetSectionsDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>>
    export type PostAPIMastersGetSectionsDetailsMutationBody = SectionDetailsReq
    export type PostAPIMastersGetSectionsDetailsMutationError = unknown

    export const usePostAPIMastersGetSectionsDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>, TError,{data: SectionDetailsReq}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersGetSectionsDetails>>,
        TError,
        {data: SectionDetailsReq},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersGetSectionsDetailsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postAPIMastersGetSubjectAllocationMasterDetails = (
    subjectAllocationMasterDetailsReq: SubjectAllocationMasterDetailsReq,
 signal?: AbortSignal
) => {
      
      
      return customAxios<SubjectAllocationMasterDetailsResApiResponse>(
      {url: `/API/Masters/GetSubjectAllocationMasterDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: subjectAllocationMasterDetailsReq, signal
    },
      );
    }
  


export const getPostAPIMastersGetSubjectAllocationMasterDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>, TError,{data: SubjectAllocationMasterDetailsReq}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>, TError,{data: SubjectAllocationMasterDetailsReq}, TContext> => {
    
const mutationKey = ['postAPIMastersGetSubjectAllocationMasterDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>, {data: SubjectAllocationMasterDetailsReq}> = (props) => {
          const {data} = props ?? {};

          return  postAPIMastersGetSubjectAllocationMasterDetails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersGetSubjectAllocationMasterDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>>
    export type PostAPIMastersGetSubjectAllocationMasterDetailsMutationBody = SubjectAllocationMasterDetailsReq
    export type PostAPIMastersGetSubjectAllocationMasterDetailsMutationError = unknown

    export const usePostAPIMastersGetSubjectAllocationMasterDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>, TError,{data: SubjectAllocationMasterDetailsReq}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersGetSubjectAllocationMasterDetails>>,
        TError,
        {data: SubjectAllocationMasterDetailsReq},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersGetSubjectAllocationMasterDetailsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postAPIMastersUpdateRecordStatusForShift = (
    params?: PostAPIMastersUpdateRecordStatusForShiftParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BooleanApiResponse>(
      {url: `/API/Masters/UpdateRecordStatusForShift`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getPostAPIMastersUpdateRecordStatusForShiftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>, TError,{params?: PostAPIMastersUpdateRecordStatusForShiftParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>, TError,{params?: PostAPIMastersUpdateRecordStatusForShiftParams}, TContext> => {
    
const mutationKey = ['postAPIMastersUpdateRecordStatusForShift'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>, {params?: PostAPIMastersUpdateRecordStatusForShiftParams}> = (props) => {
          const {params} = props ?? {};

          return  postAPIMastersUpdateRecordStatusForShift(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersUpdateRecordStatusForShiftMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>>
    
    export type PostAPIMastersUpdateRecordStatusForShiftMutationError = unknown

    export const usePostAPIMastersUpdateRecordStatusForShift = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>, TError,{params?: PostAPIMastersUpdateRecordStatusForShiftParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersUpdateRecordStatusForShift>>,
        TError,
        {params?: PostAPIMastersUpdateRecordStatusForShiftParams},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersUpdateRecordStatusForShiftMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIMastersGetAllDesignCourseDetails = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<GetAllDesignCourseDetailsResApiResponse>(
      {url: `/API/Masters/GetAllDesignCourseDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetAPIMastersGetAllDesignCourseDetailsQueryKey = () => {
    return [`/API/Masters/GetAllDesignCourseDetails`] as const;
    }

    
export const getGetAPIMastersGetAllDesignCourseDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetAllDesignCourseDetailsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>> = ({ signal }) => getAPIMastersGetAllDesignCourseDetails(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetAllDesignCourseDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>>
export type GetAPIMastersGetAllDesignCourseDetailsQueryError = unknown


export function useGetAPIMastersGetAllDesignCourseDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetAllDesignCourseDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetAllDesignCourseDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetAllDesignCourseDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetAllDesignCourseDetails>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetAllDesignCourseDetailsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIMastersUpdateFacultyDetailRecordStatus = (
    params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BooleanApiResponse>(
      {url: `/API/Masters/UpdateFacultyDetailRecordStatus`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getPostAPIMastersUpdateFacultyDetailRecordStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>, TError,{params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>, TError,{params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams}, TContext> => {
    
const mutationKey = ['postAPIMastersUpdateFacultyDetailRecordStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>, {params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams}> = (props) => {
          const {params} = props ?? {};

          return  postAPIMastersUpdateFacultyDetailRecordStatus(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIMastersUpdateFacultyDetailRecordStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>>
    
    export type PostAPIMastersUpdateFacultyDetailRecordStatusMutationError = unknown

    export const usePostAPIMastersUpdateFacultyDetailRecordStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>, TError,{params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIMastersUpdateFacultyDetailRecordStatus>>,
        TError,
        {params?: PostAPIMastersUpdateFacultyDetailRecordStatusParams},
        TContext
      > => {

      const mutationOptions = getPostAPIMastersUpdateFacultyDetailRecordStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIMastersGetStudentList = (
    params?: GetAPIMastersGetStudentListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ViewStudentListForIdCardListApiResponse>(
      {url: `/API/Masters/GetStudentList`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetStudentListQueryKey = (params?: GetAPIMastersGetStudentListParams,) => {
    return [`/API/Masters/GetStudentList`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetStudentListQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError = unknown>(params?: GetAPIMastersGetStudentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetStudentListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>> = ({ signal }) => getAPIMastersGetStudentList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetStudentListQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>>
export type GetAPIMastersGetStudentListQueryError = unknown


export function useGetAPIMastersGetStudentList<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetStudentListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetStudentList>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetStudentList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetStudentList<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError = unknown>(
 params?: GetAPIMastersGetStudentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetStudentList>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetStudentList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetStudentList<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError = unknown>(
 params?: GetAPIMastersGetStudentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetStudentList<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError = unknown>(
 params?: GetAPIMastersGetStudentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetStudentListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersGetStudentIDCardDetails = (
    params?: GetAPIMastersGetStudentIDCardDetailsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<StudentIDCardDetailsListApiResponse>(
      {url: `/API/Masters/GetStudentIDCardDetails`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersGetStudentIDCardDetailsQueryKey = (params?: GetAPIMastersGetStudentIDCardDetailsParams,) => {
    return [`/API/Masters/GetStudentIDCardDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersGetStudentIDCardDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError = unknown>(params?: GetAPIMastersGetStudentIDCardDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersGetStudentIDCardDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>> = ({ signal }) => getAPIMastersGetStudentIDCardDetails(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersGetStudentIDCardDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>>
export type GetAPIMastersGetStudentIDCardDetailsQueryError = unknown


export function useGetAPIMastersGetStudentIDCardDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError = unknown>(
 params: undefined |  GetAPIMastersGetStudentIDCardDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetStudentIDCardDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError = unknown>(
 params?: GetAPIMastersGetStudentIDCardDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersGetStudentIDCardDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError = unknown>(
 params?: GetAPIMastersGetStudentIDCardDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersGetStudentIDCardDetails<TData = Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError = unknown>(
 params?: GetAPIMastersGetStudentIDCardDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersGetStudentIDCardDetails>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersGetStudentIDCardDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIMastersDownloadCardsPdf = (
    params?: GetAPIMastersDownloadCardsPdfParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/API/Masters/DownloadCardsPdf`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIMastersDownloadCardsPdfQueryKey = (params?: GetAPIMastersDownloadCardsPdfParams,) => {
    return [`/API/Masters/DownloadCardsPdf`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIMastersDownloadCardsPdfQueryOptions = <TData = Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError = unknown>(params?: GetAPIMastersDownloadCardsPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIMastersDownloadCardsPdfQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>> = ({ signal }) => getAPIMastersDownloadCardsPdf(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIMastersDownloadCardsPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>>
export type GetAPIMastersDownloadCardsPdfQueryError = unknown


export function useGetAPIMastersDownloadCardsPdf<TData = Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError = unknown>(
 params: undefined |  GetAPIMastersDownloadCardsPdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersDownloadCardsPdf<TData = Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError = unknown>(
 params?: GetAPIMastersDownloadCardsPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>,
          TError,
          Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIMastersDownloadCardsPdf<TData = Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError = unknown>(
 params?: GetAPIMastersDownloadCardsPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIMastersDownloadCardsPdf<TData = Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError = unknown>(
 params?: GetAPIMastersDownloadCardsPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIMastersDownloadCardsPdf>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIMastersDownloadCardsPdfQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



